"use client";

import { create } from "zustand";
import type { ProductForClient } from "@/lib/shared/types/interfaces";

interface ProductQuickViewStore {
  product?: ProductForClient;
  setProduct: (product?: ProductForClient) => void;
}

/**
 * Product quick view store
 * Manages product displayed in quick view modal
 */
const useProductQuickViewStore = create<ProductQuickViewStore>((set) => ({
  product: undefined,
  setProduct: (product) => set({ product }),
}));

export default useProductQuickViewStore;
